module.exports = __webpack_public_path__ + "static/media/info-circle.c6832d48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/info-circle.svg
// module id = 1381
// module chunks = 1